import React from "react";
import { Col, Row, CardText } from "reactstrap";

import shallow from "zustand/shallow";
import NumberFormat from "react-number-format";
import Card from "reactstrap/es/Card";
import CardBody from "reactstrap/es/CardBody";
import useCurrentAccountStore from "./AccountStore";
import {
	CurrencyDisplayElement,
	DateDisplayElement,
} from "../features/deal/components/DisplayElement";
import ReactTable from "../components/tables/ReactTable";
import AcctAmortStatus from "./AcctAmortStatus";
import { getPayoffMethodLabels } from "./accountLabelUtils";

const AccountAmortizationTable = () => {
	const { account, amortizations } = useCurrentAccountStore(
		(state) => ({
			amortizations: state.amortizations,
			editAmortizations: state.editAmortizations,
			account: state.account,
		}),
		shallow
	);
	const labels = getPayoffMethodLabels(account?.payoffMethod);
	const isRTO = account?.payoffMethod === 5;

	//  int2Pay, Princ2Pay, IntPaid, PrincPaid, PropTax, PropTaxPaid, SalesTax, SalesTaxPaid, Insurance,

	const columns = React.useMemo(
		() => [
			{
				Header: "#",
				accessor: "pmtNo",
				style: { width: "20px" },
			},
			{
				Header: "Due Date",
				accessor: "dueDate",
				Cell: ({ value }) => <DateDisplayElement val={value} />,
			},
			{
				Header: "Days",
				accessor: "days",
				style: { width: "40px" },
			},
			!isRTO && {
				Header: labels.interestDue || "Int2Pay",
				accessor: "int2Pay",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			{
				Header: labels.principalDue || "Princ2Pay",
				accessor: "princ2Pay",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			!isRTO && {
				Header: labels.interestPaid || "IntPaid",
				accessor: "intPaid",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			{
				Header: labels.principalPaid || "PrincPaid",
				accessor: "princPaid",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			{
				Header: " SalesTax",
				accessor: "salesTax",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			{
				Header: "SalesTaxPaid",
				accessor: "salesTaxPaid",
				Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
			},
			{
				Header: "Actions",
				accessor: (row, index) => ({ ...row, index }), // Include the entire row and index
				disableFilters: true,
				Cell: ({ value }) => (
					<div className="d-flex justify-content-center">
						<AcctAmortStatus amort={value} acct={account} />
					</div>
				),
			},
		].filter(Boolean),
		[isRTO, labels]
	);
	const conditionalRowHighlight = (row) => {
		const totalToPay = (row.princ2Pay || 0) + (row.salesTax || 0);
		const totalPaid = (row.princPaid || 0) + (row.salesTaxPaid || 0);
		if (totalToPay < totalPaid) return "row-red";
		else if (totalToPay === totalPaid) return "row-green";
		else if (new Date(row.dueDate) < new Date()) return "row-yellow";
		else return "";
	};
	return (
		<>
			<Card>
				<CardBody>
					<div>
						<ReactTable
							data={amortizations}
							columns={columns}
							conditionalRow={conditionalRowHighlight}
						/>
					</div>
				</CardBody>
			</Card>

			<Card>
				<CardBody>
					<Row>
						<Col sm="6">
							<CardText tag="h3" className="text-center">
								Amortizations Balance
							</CardText>
						</Col>
						<Col sm="6">
							<CardText tag="h3" className="text-center">
								<NumberFormat
									value={account.balance}
									thousandSeparator={true}
									decimalScale={2}
									fixedDecimalScale={true}
									prefix={"$"}
									isNumericString={true}
									readOnly={true}
									displayType="text"
								/>
							</CardText>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</>
	);
};
export default AccountAmortizationTable;
